export default{

    isOk: false,
    error:null,
    errorMessage:'',
    modulos:'',    
    
}